module.exports = __webpack_public_path__ + "static/img/logo28.6cc8393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo28.jpg
// module id = oVwE
// module chunks = 1